import styled, { css } from 'styled-components';
import { theme } from 'styles';

// prettier-ignore
export default styled.button`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${theme.zIndices.NavDrawer - 1};
  opacity: 0;
  transition: all 0.3s, width 0s 0.3s, height 0s 0.3s;
  background: rgba(0, 0, 0, 0.4);
  width: 0;
  height: 0;

  ${props => props.isOpen && css`
    transition: all 0.3s, width 0s, height 0s;
    opacity: 1;
    width: 100vw;
    height: 100vh;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/shared/NavDrawer/components/Overlay.jsx